<template>
  <div>
    <b-table-simple
      ref="detailGrid"
      bordered
      responsive
      sticky-header
    >
      <colgroup>
        <col style="width: 150px">
        <col style="width: 100px">
        <col style="width: 100px">
        <col style="width: 100px">
        <col style="width: 100px">
      </colgroup>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="sticky-header">
            계약명
          </b-th>
          <b-th class="sticky-header">
            상세 코드
          </b-th>
          <b-th>
            해당 코드가 등록된 요양기관 수
          </b-th>
          <b-th>
            일일 팝업 노출 수
          </b-th>
          <b-th>
            데스크인포 버튼 클릭 수
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-if="data">
        <template v-for="(member, index) in data">
          <b-tr
            :key="`member-${member.contractId}-${index}`"
          >
            <b-td
              v-if="member.rowCount > 0"
              :rowspan="member.rowCount"
              contract-id
              style="left: 0"
            >{{ member.contractName }}</b-td>
            <b-td>{{ member.entryCode }}</b-td>
            <b-td>{{ member.hcpWorkPlaceCount | $numberFormatter }}</b-td>
            <b-td>{{ member.dailyPopupCount | $numberFormatter }}</b-td>
            <b-td>{{ member.buttonPopupCount | $numberFormatter }}</b-td>
          </b-tr>
        </template>

      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import {
  onMounted, ref, watch, getCurrentInstance,
} from '@vue/composition-api'

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs

    watch(() => props.data, () => {

    })

    onMounted(() => {
      // 딜레이를 줘야 table border가 제대로 적용 됨
      setTimeout(() => {
        refs.detailGrid.$el.classList.add('custom-bordered')
      }, 500)
    })

    return {
      // grandTotal,
      props,
    }
  },
}
</script>

<style scoped>
.custom-bordered .table th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}

.sticky-header {
  position: sticky;
  z-index: 99 !important;
}

.dark-layout .sticky-row {
  position: sticky;
  z-index: 3 !important;
  background-color: #283046;
}

.sticky-row {
  position: sticky;
  z-index: 3 !important;
  background-color: #fff;
}

.b-table-sticky-header {
  max-height: 650px;  /* table 15줄 이후 스크롤 */
}
</style>
